module.exports = __webpack_public_path__ + "img/icone-john-deere-connected-black.64d6339b.svg";